/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

 const React = require('react')
 const Bugsnag = require('@bugsnag/js').default
 const BugsnagPluginReact = require('@bugsnag/plugin-react').default
 
 Bugsnag.start({
   apiKey: process.env.GATSBY_BUGSNAG_API_KEY,
   plugins: [new BugsnagPluginReact()],
   releaseStage: process.env.GATSBY_STAGING || process.env.GATSBY_LOCAL ? 'staging' : 'production'
 })
 
 const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)
 
 exports.wrapRootElement = ({ element }) => (
   <ErrorBoundary>{element}</ErrorBoundary>
 )
